import { ExternalCalendarEvent } from '@griply/types';

import { formatDateKey } from './format-date-key';

export type ExternalEventBoundary = ExternalCalendarEvent['start'];

// The one place the cached-event boundary shape is encoded. Callers own the inclusive vs
// exclusive arithmetic before calling — that genuinely differs between the drag path
// (FullCalendar hands over an already-exclusive all-day end) and the form path (the form
// holds an inclusive one) — but the encoding must not drift.
export const toExternalEventBoundary = (
  allDay: boolean,
  date: Date,
): ExternalEventBoundary =>
  allDay ? { date: formatDateKey(date) } : { dateTime: date.toISOString() };
